const Actions = {
  SET_SEARCH: "SET_SEARCH",
  RESET_SEARCH: "RESET_SEARCH",
};

export default Actions;
